var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { NotificationIcon } from '../notification-icon';
import { Card } from '../card';
import { notificationStyle, contentStyle } from './styles';
import CloseButton from './close-button';
var decorVariantMap = {
    info: {
        highlightVariant: 'blue',
    },
    success: {
        highlightVariant: 'green',
    },
    warning: {
        highlightVariant: 'orangeLight',
    },
    error: {
        highlightVariant: 'red',
    },
    upgrade: {
        highlightVariant: 'purple',
    },
};
var invertedDecorVariantMap = __assign(__assign({}, decorVariantMap), { upgrade: {
        highlightVariant: 'purpleLight',
    } });
function NotificationCardInternal(_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? 'info' : _b, _c = _a.hideLeftDecor, hideLeftDecor = _c === void 0 ? false : _c, _d = _a.isContentCentered, isContentCentered = _d === void 0 ? false : _d, _e = _a.inverted, inverted = _e === void 0 ? false : _e, _f = _a.closable, closable = _f === void 0 ? false : _f, closeButtonOverride = _a.closeButtonOverride, onClose = _a.onClose, children = _a.children, restProps = __rest(_a, ["variant", "hideLeftDecor", "isContentCentered", "inverted", "closable", "closeButtonOverride", "onClose", "children"]);
    var highlightVariant = inverted
        ? invertedDecorVariantMap[variant].highlightVariant
        : decorVariantMap[variant].highlightVariant;
    function renderCloseButton() {
        function handleClick() {
            var _a, _b;
            (_b = closeButtonOverride === null || closeButtonOverride === void 0 ? void 0 : (_a = closeButtonOverride.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
        if (closable) {
            return closeButtonOverride ? (cloneElement(closeButtonOverride, {
                inverted: inverted,
                onClick: handleClick,
            })) : (_jsx(CloseButton, { inverted: inverted, onClick: onClose }));
        }
        return null;
    }
    return (_jsxs(Card, __assign({ ref: ref, role: "status", disableHoverEffect: true }, (!hideLeftDecor && {
        variant: 'highlight',
        highlightVariant: highlightVariant,
    }), { css: notificationStyle({ inverted: inverted }) }, restProps, { children: [_jsx(NotificationIcon, __assign({}, {
                variant: variant,
                inverted: inverted,
                isCentered: isContentCentered && closable,
            })), _jsx("div", __assign({ css: contentStyle({ closable: closable, isContentCentered: isContentCentered }) }, { children: children })), renderCloseButton()] })));
}
export default NotificationCardInternal;
